module.exports = __webpack_public_path__ + "static/media/img1.9780a540.jpg";